import React from 'react';
import { formatItemCount } from '../../utils/datetime';

/**
 * リスト一覧の「件数」を最下部（ページネーション下）へ中央寄せで表示する共通フッター。
 *
 * 方針（docs/DEVELOPMENT.md）: SP／コンパクト表示では件数を上部ツールバーやヘッダーに置かず、
 * この共通フッターで一覧の最下部へ集約する。上部の件数は上部レイアウトを妨げるため置かない。
 *
 * @param {number} count 表示件数（数値。null/undefined のときは何も描画しない）
 * @param {boolean} show 表示可否（通常は SP フラグ等。false のとき何も描画しない）
 */
export default function ListFootCount({ count, show = true }) {
  if (!show || typeof count !== 'number') return null;
  return (
    <div className="list-foot-count" aria-live="polite">
      {formatItemCount(count)}
    </div>
  );
}
